module.exports = __webpack_public_path__ + "files/df78fa266df459f1d6d1d557d8dcb1c5.png";